import { render, staticRenderFns } from "./Badgemap.vue?vue&type=template&id=fef6e4da&"
import script from "./Badgemap.vue?vue&type=script&lang=js&"
export * from "./Badgemap.vue?vue&type=script&lang=js&"
import style0 from "./Badgemap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports